import { HoldTransactionStatus, CaptureTransactionStatus, TransferTransactionStatus, PayoutTransactionStatus, CreditTransactionStatus, TransactionRole } from '@gopeerproject/chuck';
export const TRANSACTION_LABEL = {
    [HoldTransactionStatus.PENDING]: {
        text: 'Pending',
        value: 'pending',
        desc: 'Hold pending'
    },
    [HoldTransactionStatus.FAILED]: {
        text: 'Failed',
        value: 'failed',
        desc: 'Hold failed'
    },
    [HoldTransactionStatus.SUCCEEDED]: {
        text: 'On Hold',
        value: 'onhold',
        desc: 'Hold placed on your card'
    },
    [HoldTransactionStatus.RELEASED]: {
        text: 'Canceled',
        value: 'canceled',
        desc: 'Payment hold released'
    },
    [CaptureTransactionStatus.PENDING]: {
        text: 'Capturing',
        value: 'capturing',
        desc: 'Capture pending'
    },
    [CaptureTransactionStatus.FAILED]: {
        text: 'Failed',
        value: 'failed',
        desc: 'Capture failed'
    },
    [CaptureTransactionStatus.SUCCEEDED]: {
        text: 'Paid',
        value: 'paid',
        desc: ''
    },
    [CaptureTransactionStatus.REFUNDED]: {
        text: 'Refunded',
        value: 'refunded',
        desc: 'Payment Refunded'
    },
    [TransferTransactionStatus.PENDING]: {
        text: 'Pending',
        value: 'pending',
        desc: 'Transfer pending'
    },
    [TransferTransactionStatus.FAILED]: {
        text: 'Failed',
        value: 'failed',
        desc: 'Transfer failed'
    },
    [TransferTransactionStatus.SUCCEEDED]: {
        text: 'In Transit',
        value: 'intransit',
        desc: ''
    },
    [TransferTransactionStatus.REVERSED]: {
        text: 'Canceled',
        value: 'canceled',
        desc: ''
    },
    [PayoutTransactionStatus.PENDING]: {
        text: 'In Transit',
        value: 'v',
        desc: ''
    },
    [PayoutTransactionStatus.FAILED]: {
        text: 'Failed',
        value: 'intransit',
        desc: ''
    },
    [PayoutTransactionStatus.SUCCEEDED]: {
        text: 'Paid',
        value: 'paid',
        desc: ''
    },
    [CreditTransactionStatus.SUCCEEDED]: {
        text: 'Credit',
        value: 'credit',
        desc: 'GoPeer balance credit transaction'
    },
    [CreditTransactionStatus.REVERSED]: {
        text: 'Reversed',
        value: 'reversed',
        desc: 'GoPeer balance credit transaction reversed'
    },
    [TransactionRole.ROLLOVER]: { text: 'Rollover', value: 'rollover', desc: '' },
    [TransactionRole.SPONSORED]: {
        text: 'Sponsored',
        value: 'sponsored',
        desc: ''
    },
    [TransactionRole.PREPAID]: { text: 'Prepaid', value: 'prepaid', desc: '' },
    [TransactionRole.PARTNERSHIP]: {
        text: 'Partnership',
        value: 'partnership',
        desc: ''
    },
    [TransactionRole.REFERRAL]: { text: 'Referral', value: 'referral', desc: '' },
    TRIAL: { text: 'Free Trial', value: 'free', desc: '' }
};
//# sourceMappingURL=transactions.js.map